import { BaseElement } from '@webtides/element-js';
import SocialMediaWallStore from './social-media-wall-store';

export default class SocialMediaWallElement extends BaseElement {
    socialMediaWallStore = null;

    properties() {
        return {
            apiKey: '',
            siteUuid: '',
            channels: [],
        };
    }

    async connected() {
        this.socialMediaWallStore = new SocialMediaWallStore({
            apiKey: this.apiKey,
            siteUuid: this.siteUuid,
            channels: this.channels,
        });
        await this.socialMediaWallStore.updatePosts();
    }

    provideProperties() {
        return {
            socialMediaWallStore: this.socialMediaWallStore,
        };
    }
}
